import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledTabWrapper = styled.div`
.ui.segment[class*="bottom attached"] {
  border-top: 1px solid #d4d4d5 !important;
  border-radius: 10px !important;
}
  .wrapped {
    position: relative;
    padding-left: 5rem;
    padding-right: 5rem;
    flex-direction: row;
    justify-content: center;
    display: flex;
    border: none;
    box-shadow: none;  
    
    .not-visible: {
      display: none;
    }

    &:before {
      content: '';
      animation: ${fadeIn} 0.3s ease-in;
      display: block;
      width: 80%;
      height: 5px;
      margin-top: 1.6rem;
      bottom: 0px;
      top: 0px;
      position: absolute;
      background-color: #f0f4f9;
    }

    &:after {
      content: '';
      display: none;
    }

     .tab-item {
      display: block !important;
      text-align: center !important;
      flex: 1 1 0% !important;
      flex-grow: 0;
      position: relative !important;
      padding: 0;
      line-height: unset;
      font-weight: 500;
      cursor: pointer;
      align-items: unset !important;
    
      &:hover {
        background: transparent !important;
        .tab-number {
          border: 1px solid #66738B;
        }
      }

      &:before {
       content: '';
       display: none;
      }    

      &.active {
        background: transparent;
        animation: ${fadeIn} 0.3s ease-in;
        .tab-name {
          font-weight: bold;
        }

        .tab-number {
          background-color: #1A3175;
          color: #FFFFFF;          
        }
      }  
    }
        
    .arrow-left {
      z-index: 48;
      cursor: pointer;
      position: absolute;
      left: 0;
      top: 12px;
      i {
        font-size: 3em !important;
        background: white !important;
        padding-top: 5px !important;
        border-radius: 50% !important;
      }
     }
     .arrow-right {
      z-index: 48;
      cursor: pointer;
      position: absolute;
      right: -80px;
      bottom: -3px;
      i {
        font-size: 3em !important;
        background: white !important;
        padding-top: 5px !important;
        border-radius: 50% !important;
      }
     }

    .tab-number {
      border-radius: 9999px;
      width: 3.5rem;
      height: 3.5rem;
      display: inline-flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      border-width: 1px;
      padding-top: .5rem;
      padding-bottom: .5rem;
      padding-left: .75rem;
      padding-right: .75rem;
      background-color: #F0F4F9;
      color: #66738B;
      font-weight: bold;
      &.disable {
        cursor: not-allowed !important;
      }
      &.success {
        background-color: rgb(130, 202, 157) !important;
        color: white;          
        border-color: rgb(130, 202, 157) !important;
      }
      &.error {
        background-color: #f6d0d0 !important;
        color: #9f3a38;          
        border-color: #e0b4b4;
      }
    }

    .tab-name {
      font-size: 1rem;
      line-height: 1.5rem;
      margin-top: .75rem;
      font-weight: 500;
      margin-left: auto;
      margin-right: auto;
      width: 12rem;
    }
  }

  .default-language-group {
    margin-top: 1.2rem !important;
  }
`